export default {
  limits: ['10', '20', '30'],
  limit: 20,
  tableLimits: ['20', '50', '100'],
  tableLimit: 50,
};
